import styled from "styled-components/macro";

export const ContentContainer = styled.div`
    display: flex;
    padding: 0 41px 0px 24px;
`;
